export default __webpack_public_path__ + "static/media/dynamodblogo.3e387a27.png";